(() => {
  'use strict';

  if (window.__drevosGa4LeadTrackingV1 === true) return;
  window.__drevosGa4LeadTrackingV1 = true;

  const host = window.location.hostname.toLowerCase();
  if (host !== 'drevos.pl' && host !== 'www.drevos.pl') return;

  const measurementId = 'G-F2MTZ94R8G';
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const rules = [
    {
      path: '/pages/contact',
      formId: 'contact-us-page',
      successParam: 'contact_posted',
      formName: 'contact',
      leadType: 'contact_request'
    },
    {
      path: '/',
      formId: 'DrevosNewsletterMini',
      successParam: 'customer_posted',
      formName: 'home_checklist',
      leadType: 'checklist_signup'
    },
    {
      path: '/pages/wspolpraca',
      formId: 'DrevosPartnershipForm',
      successParam: 'contact_posted',
      formName: 'partnership',
      leadType: 'partner_request'
    }
  ];

  const rule = rules.find((candidate) => candidate.path === path);
  if (!rule) return;

  const storageKey = `drevos:ga4:generate_lead:${rule.formName}`;
  const attachFormReset = () => {
    const form = document.getElementById(rule.formId);
    if (!form) return;

    form.addEventListener('submit', () => {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (error) {
        // Tracking must not interfere with the Shopify form.
      }
    }, { capture: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachFormReset, { once: true });
  } else {
    attachFormReset();
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get(rule.successParam) !== 'true') return;

  try {
    if (window.sessionStorage.getItem(storageKey) === 'sent') return;
    window.sessionStorage.setItem(storageKey, 'sent');
  } catch (error) {
    // If storage is unavailable, send the confirmed lead without deduplication.
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('event', 'generate_lead', {
    send_to: measurementId,
    method: 'shopify_form',
    form_id: rule.formId,
    form_name: rule.formName,
    lead_type: rule.leadType,
    page_path: path,
    transport_type: 'beacon'
  });

  window.__drevosGa4LeadLastEvent = {
    event: 'generate_lead',
    send_to: measurementId,
    form_id: rule.formId,
    form_name: rule.formName,
    lead_type: rule.leadType
  };
})();
